export const handleEmptyStringCheck = (string) => {
    return string && string.replace(/\s/g, '').length
}
